import { EntityTypes } from 'constants/entities';
import { ICopy, ICopyItem, ICopyResponse } from 'core/actions/admin/diagram';
import { IActionDAO } from 'types/domain/action';
import { INode } from 'types/domain/base';
import { IEntityReducer } from '..';
import merge, { mergeOffline } from './merge';

export function copy(state, action) {
  const { items, parentEntityType, offset, targetEntityId } = action.meta.arg as ICopy;

  if (items && state[parentEntityType]) {
    const copies = items.map(item => updateItem(state, item, parentEntityType, targetEntityId, offset));
    merge(state, EntityTypes.ACTION, null, copies);
  }
}

function updateItem(
  state: IEntityReducer,
  item: ICopyItem,
  parentEntityType: EntityTypes,
  targetEntityId: number,
  offset: INode,
) {
  const entities = state[item.type];

  const entity = {
    ...(entities[item.id] || {}),
    id: item.offlineId,
    nodeId: item.offlineId,
    offlineId: item.offlineId,
    // entities: Object.values(state[EntityTypes.ACTION_ENTITY])
    //   .filter((ent: IActionEntity) => ent.actionId === item.id)
    //   .map(ent => {
    //     return {
    //       id: item.offlineId,
    //       offlineId: item.offlineId,
    //     } as IActionEntity;
    //   }),
  } as IActionDAO;

  const node = {
    id: item.offlineId,
    offlineId: item.offlineId,
    x: item.node.x + (offset ? offset.x : 50),
    y: item.node.y + (offset ? offset.y : 50),
  };

  switch (parentEntityType) {
    case EntityTypes.COURSE:
      return {
        ...entity,
        node,
        courseId: targetEntityId,
      };
    case EntityTypes.MODULE:
      return {
        ...entity,
        node,
        moduleId: targetEntityId,
      };
    case EntityTypes.STRUCTURE:
      return {
        ...entity,
        node,
        structureId: targetEntityId,
      };
  }
}

export function mergeCopyOffline(state, action) {
  const { items } = action.payload as ICopyResponse;

  items.forEach((item: IActionDAO) => {
    mergeOffline(state, item.type, item.id, item);

    if (item.node) mergeOffline(state, EntityTypes.NODE, item.id, item.node);
  });
}
